export default __webpack_public_path__ + "static/media/MariahCarey.2c787d6b.mp3";